import { Navigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { APP_ROUTES } from '@/common/constants'
import { useClientsLogic } from './features/clients/useClientsLogic'
import { ClientsTable } from './features/clients/components/ClientsTable'
import { ClientsTableWithTabs } from './features/clients/components/ClientsTableWithTabs'

/**
 * Entry page for the adviser /clients route.
 *
 * Guards:
 *  - Non-adviser active accounts are redirected to dashboard.
 *  - Adviser accounts see the client list.
 */
export default function ClientsPage() {
    const logic = useClientsLogic()

    if (!logic.isAdviserWorkspaceAccount) {
        return <Navigate to={APP_ROUTES.DASHBOARD} replace />
    }

    // Show original ClientsTable for switching/empty states
    if (logic.clientAccounts.length === 0 && logic.inProgressClients.length === 0) {
        return (
            <>
                <Helmet>
                    <title>Clients | {APP.title}</title>
                </Helmet>
                <ClientsTable
                    filteredAccounts={[]}
                    activeAccountId={logic.activeAccountId}
                    hasClientAccounts={false}
                    onAddClient={logic.handleAddClient}
                    onSelectAccount={logic.handleSelectAccount}
                />
            </>
        )
    }

    return (
        <>
            <Helmet>
                <title>Clients | {APP.title}</title>
            </Helmet>
            <ClientsTableWithTabs
                activeTab={logic.activeTab}
                onTabChange={logic.setActiveTab}
                activeAccounts={logic.clientAccounts}
                activeCount={logic.clientAccounts.length}
                inProgressClients={logic.inProgressClients}
                inProgressCount={logic.inProgressClients.length}
                activeAccountId={logic.activeAccountId}
                onAddClient={logic.handleAddClient}
                onSelectAccount={logic.handleSelectAccount}
                onResumeClient={logic.handleResumeClient}
            />
        </>
    )
}
